import React from 'react';

import UpdatedPopover from '../../UpdatedPopover/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 'k',
  title: 'Last Updated Time'
};


var HeaderColumn = function() {
  return <th></th>;
}


var DetailColumn = function(props) {
  return (
    <td>
      <UpdatedPopover timestamp={props.row.lastUpdated} />
    </td>
  );
}


class LastUpdated extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default LastUpdated;

